import { type RootState } from '../../stores/redux';

export const getWaitingRoom = (state: RootState) => state.waitingRoom;

export const getWaitingRoomAdminSubscriptionType = (state: RootState) =>
  state.waitingRoom.roomAdmin.subscriptionType;
